import {
    convertRoutesToUIModel, cutRoute,
    fetchPickMetrics,
    fetchRouteInformation,
    getFilterData,
    prioritizeRoute,
    sideLineRoute,
    unassignAssociate,
    updatePrioritizedRoutes,
    getPickStatusInGrid,
    prioritizePickAssist,
    unassignPickAssist,
} from "../network/PickNetworkAPI";
import {CORE_AMZL} from "../../util/Constants";
import {PICK_STATUS_IN_GRID_CACHE_KEY, ROUTE_DATA_CACHE_KEY} from "../../util/LocalStorageKeys";
import {
    clearCache,
    getDataWithExpiry,
    isPickStatusInGridCacheValid,
    isRouteCacheValid,
    setDataWithExpiry
} from "../../util/CacheManager";
import {
    logCounterMetric, PICK_STATUS_IN_GRID_CACHE_HIT_METRIC, PICK_STATUS_IN_GRID_CACHE_MISS_METRIC,
    PICK_TAB_METRIC_KEY,
    ROUTE_CACHE_HIT_METRIC,
    ROUTE_CACHE_MISS_METRIC
} from "../../util/MetricUtil";
import {getStationCode} from "../../network/NetworkUtil";

export const PickReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
        {
            const {dispatcher, filterDispatcher, baseUrl, capability, xptNodes, stationConfig, configDispatch} = action.data;
            if (capability === CORE_AMZL) {
                //try to load data from cache if xpt filters and ttl is valid.
                if (isRouteCacheValid(xptNodes)) {
                    logCounterMetric(getStationCode(), PICK_TAB_METRIC_KEY, ROUTE_CACHE_HIT_METRIC);
                    const {cachedData, lastUpdated} = getDataWithExpiry(ROUTE_DATA_CACHE_KEY);
                    dispatcher({
                        type: "RECEIVE_DATA",
                        data: convertRoutesToUIModel(cachedData.response, capability, stationConfig),
                        lastUpdated: lastUpdated
                    });
                    filterDispatcher({type: "RECEIVE_FILTER_DATA", data: getFilterData(cachedData.response)})
                    return state
                } else {
                    logCounterMetric(getStationCode(), PICK_TAB_METRIC_KEY, ROUTE_CACHE_MISS_METRIC);
                }
            }
            fetchRouteInformation(dispatcher, filterDispatcher, baseUrl, capability, xptNodes, stationConfig, configDispatch);
            fetchPickMetrics(dispatcher, baseUrl, capability, stationConfig);
            return state
        }
        case "REFRESH_VIEW":
        {
            const {dispatcher, filterDispatcher, baseUrl, capability, xptNodes, stationConfig} = action.data;
            fetchRouteInformation(dispatcher, filterDispatcher, baseUrl, capability, xptNodes, stationConfig);
            return state
        }
        case "UPDATE_ROUTE_DATA_CACHE":
        {
            setDataWithExpiry(ROUTE_DATA_CACHE_KEY, action.data, action.lastUpdated);
            return state
        }
        case "UNLOAD_VIEW":
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data, lastUpdated: action.lastUpdated}
        case "RECEIVE_SIDELINE_COUNT":
        {
            const {sidelinedPackages} = action.data;
            return {...state, sidelinedPackages}
        }
        case "RECEIVE_INDUCTED_COUNT":
        {
            const { inductedPackageCount } = action.data;
            return { ...state, totalPackages: inductedPackageCount }
        }
        case "PRIORITIZE_ROUTE":
        {
            prioritizeRoute(action.data);
            return state;
        }
        case "UPDATE_PRIORITIZED_ROUTES":
        {
            const {stationConfig, prioritizedRoutes} = action.data;
            let routeList = updatePrioritizedRoutes(prioritizedRoutes, [...state.routeList], stationConfig);
            clearCache(ROUTE_DATA_CACHE_KEY);
            return { ...state, routeList: routeList};
        }
        case "SIDELINE_ROUTE":
        {
            const {dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig} = action.data;
            sideLineRoute(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig, PICK_TAB_METRIC_KEY);
            return state;
        }
        case "UNASSIGN_ASSOCIATE":
        {
            unassignAssociate(action.data);
            return state;
        }
        case "PRIORITIZE_PICK_ASSIST":
        {
            prioritizePickAssist(action.data);
            return state;
        }
        case "UNASSIGN_PICK_ASSIST":
        {
            unassignPickAssist(action.data);
            return state;
        }
        case "CUT_ROUTE":
        {
            const {dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig} = action.data;
            cutRoute(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig);
            return state;
        }
        case "LOAD_PICK_STATUS_IN_GRID":
        {
            const {dispatcher, baseUrl, capability, xptNodes, stationConfig, configDispatch} = action.data;
            if (capability === CORE_AMZL) {
                //try to load data from cache if xpt filters and ttl is valid.
                if (isPickStatusInGridCacheValid(xptNodes)) {
                    logCounterMetric(getStationCode(), PICK_TAB_METRIC_KEY, PICK_STATUS_IN_GRID_CACHE_HIT_METRIC);
                    const {cachedData, lastUpdated} = getDataWithExpiry(PICK_STATUS_IN_GRID_CACHE_KEY);
                    return {...state, ...action.data, picklistsInAisleGroups: cachedData.response.picklistsInAisleGroups, lastUpdated: lastUpdated};
                } else {
                    logCounterMetric(getStationCode(), PICK_TAB_METRIC_KEY, PICK_STATUS_IN_GRID_CACHE_MISS_METRIC);
                }
            }
            getPickStatusInGrid(dispatcher, baseUrl, capability, stationConfig, configDispatch, xptNodes);
            return state
        }
        case "RECEIVE_PICK_STATUS_IN_GRID_DATA":
        {
            return {...state, ...action.data, picklistsInAisleGroups: action.response.picklistsInAisleGroups,
                picklistsInWorkGroups: action.response.picklistsInWorkGroups, lastUpdated: action.lastUpdated};
        }
        case "UPDATE_PICK_STATUS_IN_GRID_DATA_CACHE":
        {
            setDataWithExpiry(PICK_STATUS_IN_GRID_CACHE_KEY, action.data, action.lastUpdated);
            return state
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/pickStatus/reducers/PickReducer.js